import { useQuery } from '@tanstack/react-query';

import { LiveClassBookingService } from '../services/liveclass-booking';

export function usePlayLearnMeeting() {
  const { data, error, isLoading, isFetching, isError } = useQuery({
    queryFn: LiveClassBookingService.getPlay2LearnMeeting,
    retry: 3,
  });

  return {
    data,
    error,
    isLoading,
    isFetching,
    isError,
  };
}
